import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote } from 'lucide-react';
import { AnimatedSection, AnimatedText, sectionVariants } from '../animations';

const ClientShowcase = () => {
    // This can remain static or be fetched from the DB as well
    const logos = ["Dream Makers", "TheTravel360", "Styleup.lk", "RealSmart Global", "Smart Home LK", "GarnishMe Cocktails", "Fintech Solutions", "Smart Solution Academy"];
    const duplicatedLogos = [...logos, ...logos]; // Create duplicates for seamless loop
    
    return (
        <div className="relative w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)] dark:[mask-image:linear-gradient(to_right,transparent,black_20%,black_80%,transparent)]">
            <motion.div 
                className="flex gap-16 min-w-max"
                animate={{ x: ['0%', '-50%'] }}
                transition={{ ease: 'linear', duration: 30, repeat: Infinity }}
            >
                {duplicatedLogos.map((logo, index) => (
                    <div key={`${logo}-${index}`} className="flex-shrink-0 text-2xl font-semibold text-gray-400 dark:text-gray-600 grayscale hover:grayscale-0 transition-all whitespace-nowrap">
                        {logo}
                    </div>
                ))}
            </motion.div>
        </div>
    );
}

// The component now accepts 'testimonials' as a prop
const ClientsSection = ({ testimonials }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (testimonials.length === 0) return; // Don't start the timer if there are no testimonials

        const timer = setInterval(() => {
            setIndex(prev => (prev + 1) % testimonials.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [testimonials]); // The effect re-runs if the testimonials data changes

    return (
        <AnimatedSection id="clients" className="bg-white dark:bg-black text-slate-900 dark:text-white">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <AnimatedText text="Trusted By The Best." className="text-4xl md:text-6xl font-bold" variants={sectionVariants}/>
                </div>
                <ClientShowcase />
                <div className="max-w-4xl mx-auto text-center mt-20">
                    <div className="relative h-48">
                        <AnimatePresence mode="wait">
                            {/* Check if testimonials exist before trying to display one */}
                            {testimonials.length > 0 && (
                                <motion.div
                                    key={index} // Animate when the index changes
                                    className="absolute inset-0"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    <Quote className="mx-auto text-blue-200 dark:text-cyan-700 mb-4" size={40} />
                                    <p className="text-xl md:text-2xl italic text-gray-800 dark:text-gray-200">"{testimonials[index].quote}"</p>
                                    <p className="mt-6 font-bold text-lg">{testimonials[index].author}</p>
                                    <p className="text-gray-500 dark:text-gray-400">{testimonials[index].company}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </AnimatedSection>
    );
};

export default ClientsSection;
